import React, { useState, useEffect } from 'react';

import { Button, IconButton } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';

import { any, bool } from 'prop-types';

import SnackBar from '../SnackBar';

function SnackBarProductAdd({ addError, addSuccess, isMobile }) {
  const [open, setOpen] = useState({ open: false });

  const handleClose = () => {
    setOpen({ open: false });
  };

  useEffect(() => {
    if (addError) {
      setOpen({
        open: true,
        message: addError.message || 'Erro ao adicionar item no carrinho',
        type: 'error',
      });
    }

    if (addSuccess) {
      setOpen({
        open: true,
        message: 'Item adicionado ao carrinho com sucesso',
        type: 'success',
        action: isMobile ? (
          <IconButton
            key="cart"
            href="/carrinho"
            size="small"
            color="inherit"
            title="Ver carrinho"
            aria-label="Ver Carrinho"
          >
            <ShoppingCart fontSize="small" />
          </IconButton>
        ) : (
          <Button color="inherit" size="small" variant="outlined" key="cart" href="/carrinho" title="Ver carrinho">
            Carrinho
          </Button>
        ),
      });
    }
  }, [addError, addSuccess, isMobile]);

  return <SnackBar {...open} onClose={handleClose} />;
}

SnackBarProductAdd.propTypes = {
  addError: any,
  addSuccess: bool,
  isMobile: bool,
};

export default SnackBarProductAdd;
